import APIService from '../Core/APIService';
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
import type { ConditionResponse } from '../../Types/schema-helpers';

export default class AutocompleteCieService extends APIService {
  /**
   * Searches CIE conditions with optional AbortSignal for request cancellation
   */
  async searchConditions(
    query: string, 
    signal?: AbortSignal
  ): Promise<ConditionResponse[]> {
    const route = API_ROUTES.search_conditions(query);
    
    return await this.get<ConditionResponse[]>(
      route, 
      signal ? { signal } : undefined
    );
  }
}